import * as React from 'react'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import APageRow from '../../components/atoms/APageRow'
import AButtonGroup from '../../components/atoms/AButtonGroup'
import AButton from '../../components/atoms/AButton'
import { deleteReport } from './reports.actions'

interface IDeleteReport extends IApiConsumer {
    id: number
    customerId: string
    name: string
    back: string
    onSuccess: () => void
}

class DeleteReport extends React.Component<IDeleteReport> {
    handleDelete = () => {
        return this.props.dispatch(deleteReport(this.props.customerId,this.props.id)).then(res => {
            return this.props.onSuccess()
        })
    }

    render() {
        const { back } = this.props
        console.log(this.props.id + "id of report")
        return (
            <APageRow
                title={`Are you sure you want to delete report '${this.props.name}'`}
            >
                <AButtonGroup>
                    <AButton color="primary" to={back}>
                        No, take me back to safety!
                    </AButton>
                    <AButton outline color="error" onClick={this.handleDelete}>
                        Yes I am sure! Delete this repport permanently from the system
                    </AButton>
                </AButtonGroup>
            </APageRow>
        )
    }
}

export default apiConsumer({
})(DeleteReport)
